/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingnotconnectedplatform3Inputs */

const en_crosspostingnotconnectedplatform3 = /** @type {(inputs: Crosspostingnotconnectedplatform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect this account for this place before publishing.`)
};

const de_crosspostingnotconnectedplatform3 = /** @type {(inputs: Crosspostingnotconnectedplatform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dieses Konto für diesen Ort, bevor du veröffentlichst.`)
};

/**
* | output |
* | --- |
* | "Connect this account for this place before publishing." |
*
* @param {Crosspostingnotconnectedplatform3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingnotconnectedplatform3 = /** @type {((inputs?: Crosspostingnotconnectedplatform3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingnotconnectedplatform3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingnotconnectedplatform3(inputs)
	return de_crosspostingnotconnectedplatform3(inputs)
});
export { crosspostingnotconnectedplatform3 as "crosspostingNotConnectedPlatform" }